import { gql } from "@apollo/client";

export const SAVE_WAREHOUSE_LOCATION_INFO = gql`
    mutation SaveWarehouseLocationInfo($request: WarehouseLocationInfoSaveRequestInput!) {
        saveWarehouseLocationInfo(request: $request)
    }
`;

export interface WarehouseLocationInfoSaveRequestInput {
    locationNoList: string[];
    warehouseId: number;
}

export interface SaveWarehouseLocationInfoResponse {
    saveWarehouseLocationInfo: boolean;
}

